import { render, staticRenderFns } from "./AllegeApply.vue?vue&type=template&id=2b715e47"
import script from "./AllegeApply.vue?vue&type=script&lang=js"
export * from "./AllegeApply.vue?vue&type=script&lang=js"
import style0 from "./AllegeApply.vue?vue&type=style&index=0&id=2b715e47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports